import React from 'react'

const NotifUpdated = () => {

    return (
        <div>
            <div className="notification is-warning is-inline-block">
                <p>Les données pour la France sont mise à jour aux alentours de 20H00</p>
            </div>
        </div>

    )
}

export default NotifUpdated